import { useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";

const IDLE_TIMEOUT_MS = 10 * 60 * 1000; // 15 minutes
const ACTIVITY_EVENTS = ["mousemove", "keydown", "click", "scroll", "touchstart"];

function useIdleTimeout() {
  const navigate = useNavigate();
  const timerRef = useRef(null);

  const logout = useCallback(() => {
    localStorage.clear();
    navigate("/");
  }, [navigate]);

  const resetTimer = useCallback(() => {
    clearTimeout(timerRef.current);
    // Only start timer if user is logged in
    if (localStorage.getItem("regno")) {
      timerRef.current = setTimeout(logout, IDLE_TIMEOUT_MS);
    }
  }, [logout]);

  useEffect(() => {
    // Start timer on mount if logged in
    resetTimer();

    ACTIVITY_EVENTS.forEach((event) => {
      window.addEventListener(event, resetTimer, { passive: true });
    });

    return () => {
      clearTimeout(timerRef.current);
      ACTIVITY_EVENTS.forEach((event) => {
        window.removeEventListener(event, resetTimer);
      });
    };
  }, [resetTimer]);
}

export default useIdleTimeout;
